import { trace } from "rytm-helpers"

const MAX_WAITING_FRAMES = 200

const keyMap = {
  81: "q",
  87: "w",
  69: "e",
  82: "r",
  84: "t",
  89: "y",
  85: "u",
  73: "i",
  79: "o",
  80: "p",
  65: "a",
  83: "s",
  68: "d",
  70: "f",
  71: "g",
  72: "h",
  74: "j",
  75: "k",
  76: "l",
  90: "z",
  88: "x",
  67: "c",
  86: "v",
  66: "b",
  78: "n",
  77: "m"
}

class KeyboardController {

  /**
  * KeyboardController class constructor  
  * @constructor
  **/
  constructor() {
    this.currentLetter = null,
    this.currentFrame = -MAX_WAITING_FRAMES
  }

  destroy() {
    this.currentLetter = null,
    this.currentFrame = 0
  }
  onKeyDown(e, frame) {
    const code = e.keyCode || e.which;
    this.currentLetter = keyMap[code]
    this.currentFrame = frame
  }
  isKeyboardOn(frame) {
    const dur = frame - this.currentFrame
    return dur < MAX_WAITING_FRAMES
  }
  resetLetter() {
    this.currentLetter = null
  }
  randomKey(frame) {
    this.currentLetter = this._getRandomLetter()
    this.currentFrame = frame
    // trace("RANDOM KEY", frame)
  }

  /**
   * ### PRIVATE ###
   */
  _getRandomLetter() {
    const keys = Object.keys(keyMap);
    return keyMap[keys[ keys.length * Math.random() << 0]]
  }

}

export default KeyboardController